import React from "react";
import { useField } from "formik";

import Checkbox from "./Checkbox";

const FormikCheckbox = ({
  name,
  disabled,
  wrapperClassName,
  contentClassName,
  errorClassName,
  className,
  children,
  ...props
}) => {
  const [field] = useField({ name, type: "checkbox" });

  return (
    <Checkbox
      wrapperClassName={wrapperClassName}
      contentClassName={contentClassName}
      errorClassName={errorClassName}
      className={className}
      {...field}
      {...props}
      value={field.checked}
      disabled={disabled}
    >
      {children}
    </Checkbox>
  );
};

export default FormikCheckbox;
